const BalloonFlying = function (scene, balloon) {
  this.scene = scene;
  this.balloon = balloon;
  this.flyingTime = 15000 + Math.round(Math.random() * 12000);
  this.padding = 120;
  this.maxX = this.scene.game.config.width - this.padding * 2;
  this.direction = 1;
  this.tweenH = null;
  this.tweenV = null;
  this.tweenBack = null;
  return this;
};

BalloonFlying.prototype.getRandomY = function () {
  return 200 + Math.round(Math.random() * 150);
};

BalloonFlying.prototype.start = function () {
  this.balloon.y = this.getRandomY();
  this.balloon.x = this.padding + Math.round(Math.random() * this.maxX);
  this.fly();
};

BalloonFlying.prototype.fly = function () {
  const speed = this.maxX / this.flyingTime;
  // eslint-disable-next-line max-len
  const currentDistance = this.direction === 1 ? this.maxX - this.balloon.x : this.balloon.x - this.padding;
  const neededTime = currentDistance / speed;

  const randomDistance = 20 + Math.round(Math.random() * 80);
  const targetX = this.direction === 1 ? this.maxX : this.padding;
  this.tweenH = this.scene.tweens.add({
    targets: this.balloon,
    x: targetX,
    duration: neededTime,
    ease: 'Linear',
    onComplete: this.movementHorizontalComplete.bind(this),
  });
  this.tweenV = this.scene.tweens.add({
    targets: this.balloon,
    y: this.balloon.y - randomDistance,
    duration: 1200,
    ease: 'Sine.easeInOut',
    yoyo: true,
    repeat: -1,
  });
};

BalloonFlying.prototype.movementHorizontalComplete = function () {
  this.direction *= -1;
  const speed = this.maxX / this.flyingTime;
  // eslint-disable-next-line max-len
  const currentDistance = this.direction === 1 ? this.maxX - this.balloon.x : this.balloon.x - this.padding;
  const neededTime = currentDistance / speed;
  const targetX = this.direction === 1 ? this.maxX : this.padding;
  this.tweenH = this.scene.tweens.add({
    targets: this.balloon,
    x: targetX,
    duration: neededTime,
    ease: 'Linear',
    onComplete: this.movementHorizontalComplete.bind(this),
  });
};

BalloonFlying.prototype.stop = function () {
  if (this.tweenH) this.tweenH.stop();
  if (this.tweenV) this.tweenV.stop();
  if (this.tweenBack) this.tweenBack.stop();
};

BalloonFlying.prototype.backToFlying = function () {
  const y = this.getRandomY();
  const x = this.balloon.x;

  this.tweenBack = this.scene.tweens.add({
    targets: this.balloon,
    x,
    y,
    duration: 2000,
    ease: 'Sine.easeInOut',
    onComplete: this.fly.bind(this),
  });
};

export default BalloonFlying;
